import * as React from "react";

import { LimeButton } from "../Buttons/Lime";
import PerksWealth from "../Perks/PerksWealth";
import { LimeButtonRoute } from "../Buttons/LimeRoute";

export default function SectionWealth({ textData, cardItemsWealth }) {
    return (
        <section id="wealth-section" className="section_invest">
            <div id="changex_slider" className={`${textData.background}`}>
                <div className="container-large">
                    <div data-aos='fade-up'
                        data-aos-duration='1000'
                        className="padding-global" >
                        <div className="money-wealth">
                            <div className={`${textData.head ? 'bank-image-comming-soon' : 'hide'}`}>{textData.head}</div>
                            <h2 className="heading-style-h2">
                                {textData.h1}
                            </h2>
                            <h2 className="heading-style-h2-no-margin margin-bottom margin-small is-green">
                                {textData.h2}
                            </h2>
                            <p className="text-align-left paragraph24 text-color-grey">
                                {textData.h3}
                            </p>
                        </div>
                        <PerksWealth perksArray={cardItemsWealth}></PerksWealth>
                        <div className="spacer-big"></div>
                        <div
                            className={`${textData.button ? "" : "hide"
                                }`}>
                            <div className={`${textData.route ? "hide" : ""}`}>
                                <LimeButton text={textData.buttonTxt} url={textData.buttonUrl} size={'large'} />
                            </div>
                            <div className={`${textData.route ? "" : "hide"}`}>
                                <LimeButtonRoute text={textData.buttonTxt} url={textData.buttonUrl} size={'large'} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
